import React, { useMemo, useState } from 'react';
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from '@mui/material';
import PropTypes from 'prop-types';

const texts = {
  cancel: 'Cancel',
  submit: 'OK',
};

const PromptDialog = ({
  open,
  title,
  description,
  InputComponent = ({ value, setValue, ...props }) => (
    <TextField
      {...props}
      value={value}
      onChange={(e) => setValue(e.target.value)}
    />
  ),
  cancellable = true,
  required = false,
  onSubmit = () => null,
  onClose = () => null,
  buttons,
  defaultValue = '',
  validate = (v) => v !== '',
}) => {
  const [value, setValue] = useState(defaultValue);
  const text = useMemo(
    () => ({
      ...texts,
      ...buttons,
    }),
    [buttons],
  );

  const isValid = useMemo(() => {
    return validate(value);
  }, [validate, value]);

  const handleCancel = (e) => {
    setValue(defaultValue);
    onClose(e);
  };

  const handleSubmit = () => {
    if (required && !isValid) {
      return;
    }
    onSubmit(value);
  };
  return (
    <Dialog open={open}>
      {title && <DialogTitle>{title}</DialogTitle>}
      <DialogContent sx={{ overflow: 'visible', pt: 2 }}>
        {description && <div style={{ marginBottom: 8 }}>{description}</div>}
        <InputComponent
          value={value}
          setValue={setValue}
          required={required}
          autoFocus
        />
      </DialogContent>
      <DialogActions>
        {cancellable && (
          <Button variant='text' onClick={handleCancel}>
            {text.cancel}
          </Button>
        )}

        <Button
          variant='contained'
          color='primary'
          onClick={handleSubmit}
          disabled={!isValid}
        >
          {text.submit}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

PromptDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  cancellable: PropTypes.bool,
  required: PropTypes.bool,
  InputComponent: PropTypes.func,
  validate: PropTypes.func,
  buttons: PropTypes.shape({
    submit: PropTypes.string,
    cancel: PropTypes.string,
  }),
  defaultValue: PropTypes.string,
};

export default PromptDialog;
